/**
 * 
 */
 import React from "react";
//import Button from "./Button";

const DataGrid2 = (props) => {
  let i = 0; // use for id counter

  // dataGrid will only one or two fixed functions,
  // both function defind in parent file.
  // component will pass back the item key
  // can't pass in using json,
 /* function defaultButton1Action(e, id) {
    if (props.button1Action === undefined || props.button1Action === null) {
      console.log("no default function found, you clicked on " + e);
    } else {
      console.log("parent called me");
      props.button1Action(id);
    }
  }
  */
  
  // second button action/function
  /*function defaultButton2Action(e, id) {
    if (props.button2Action === undefined || props.button2Action === null) {
      console.log("no default function found, you clicked on " + e);
    } else {
      console.log("parent called me");
      props.button1Action(id);
    }
  }
  */

  return (
    <>
      {props.data.map((item, index) => (
        <div>
          <hr className={props.isDeclined && (item.label === "Program Scheduling in Progress" || item.label === "Acceptance Package Sent") ? "hide_div" : "hr_bch"} />
          <div className={props.isDeclined && (item.label === "Program Scheduling in Progress" || item.label === "Acceptance Package Sent") ? "hide_div" : "dataGrid"}>
            <div
              className="dataGrid__icon"
              id={"datagrid_icon_" + item.id + "_" + i++}
              style={
                item.status !== undefined &&
                item.status !== "" &&
                item.status.toString().toLowerCase() === "notstarted"
                  ? {}
                  : { display: "none" }
              }
            >
              <span class="icon-notStarted"></span>
            </div>
            <div
              className="dataGrid__icon"
              id={"datagrid_icon_" + item.id + "_" + i++}
              style={
                item.status !== undefined &&
                item.status !== "" &&
                item.status.toString().toLowerCase() === "started"
                  ? {}
                  : { display: "none" }
              }
            >
              <span class="icon-started"></span>
            </div>
            <div
              className="dataGrid__icon"
              id={"datagrid_icon_" + item.id + "_" + i++}
              style={
                item.status !== undefined &&
                item.status !== "" &&
                item.status.toString().toLowerCase() === "completed"
                  ? {}
                  : { display: "none" }
              }
            >
              <span class="icon-completed"></span>
            </div>
            <div
              className="dataGrid__label dataGrid2__label"
              id={"datagrid_content_" + item.id + "_" + i++}
              style={
                item.content !== undefined && item.content !== ""
                  ? {}
                  : { display: "none" }
              }
            >
              {item.content}
            </div>
            <div
              className="dataGrid__content dataGrid__content--string dataGrid2__content--string"
              style={
                item.label !== undefined && item.label.length > 0
                  ? {}
                  : { display: "none" }
              }
              id={"datagrid_label_" + item.id + "_" + i++}
              //id={item.id+"datagrid"}
            >
              {item.label}
            </div>
          </div>
        </div>
      ))}
      <hr className="hr_bch" />
    </>
  );
};

export default DataGrid2;